var insertResults = require('./insert-results');

module.exports = function (apiEndpoint) {
    var topicContentDesktop = document.getElementById('TopicFiltering');
    var topicContentTouch = document.getElementById('TopicFilteringModal');
    var regionContentDesktop = document.getElementById('RegionFiltering') || document.getElementById('person-index__region-dropdown__desktop-content');
    var regionContentTouch = document.getElementById('RegionFilteringModal') || document.getElementById('person-index__region-dropdown__touch-content');
    var contentLabelContentDesktop = document.getElementById('ContentLabelFiltering');
    var contentLabelContentTouch = document.getElementById('ContentLabelFilteringModal');

    var $topicContentDesktopContent, $regionContentDesktopContent, $contentLabelContentDesktopContent;
    var $topicModal, $regionModal, $contentLabelModal;
    var topicTooltip, regionTooltip, contentLabelTooltip;

    var collapseGroupActiveClass = 'popover__group--expanded';
    var triggerActiveClass = 'circle-plus-minus-icon--is-active';

    var setPopoverGroup = function(group) {
      var $popoverGroup = $('.popover__group', group);
      $($popoverGroup).each(function () {
        var $popoverGroupTitle = $(this).find('.popover__group-title');
        var $popoverGroupTitvarext = $($popoverGroupTitle).text();
        $($popoverGroupTitle).attr('title', $popoverGroupTitvarext);
        $($popoverGroupTitle).append('<span></span>');
      });
    }

    var updateNumberOfChecked = function(content) {
      var $popoverGroup = $('.popover__group', content);

      $($popoverGroup).each(function () {
        var $popoverGroupTitle = $(this).find('.popover__group-title');
        var $checkedBoxes = $(this).find('input:checked');
        $($popoverGroupTitle).find('span').empty();
        if($checkedBoxes.length > 0) {
          $($popoverGroupTitle).find('span').append('('+$checkedBoxes.length+')');
        }
        else {
          $($popoverGroupTitle).find('span').empty();
        }
      });
    }

    var updateFiltersAndContent = function () {
      if($('.dropdown-filter--topic').length) {
        if (window.topics.length) {
            $('.dropdown-filter--topic').addClass('dropdown-filter--active');
        }
        else {
            $('.dropdown-filter--topic').removeClass('dropdown-filter--active');
        }
      }

      if($('.dropdown-filter--region').length) {
        if (window.regions.length) {
            $('.dropdown-filter--region').addClass('dropdown-filter--active');
        }
        else {
            $('.dropdown-filter--region').removeClass('dropdown-filter--active');
        }
      }

      if($('.dropdown-filter--content-label').length) {
        if (window.contentLabels.length) {
            $('.dropdown-filter--content-label').addClass('dropdown-filter--active');
        }
        else {
            $('.dropdown-filter--content-label').removeClass('dropdown-filter--active');
        }
      }
        if(!window.topics) {
          window.topics = [];
        }

        if(!window.regions) {
          window.regions = [];
        }

        if(!window.contentLabels) {
          window.contentLabels = [];
        }

        if (window.topics.length || window.regions.length || window.contentLabels.length) {
            $('.dropdown-filters').addClass('dropdown-filters--active');
        }
        else {
            $('.dropdown-filters').removeClass('dropdown-filters--active');
        }

        window.page = 1;
        window.topicMatchType = '';

        insertResults(apiEndpoint);
    };

    if (topicContentDesktop) {
        setPopoverGroup(topicContentDesktop);
        topicTooltip = tippy('.dropdown-filter--topic--desktop', {
            maxWidth: 'none',
            theme: 'light full-width',
            placement: 'bottom-start',
            flip: false,
            content: topicContentDesktop,
            onMount: function (instance) {
                var $instance = $(instance.popper);
                var $content = $(instance.props.content);
                resizeTopicDropdown();

                var $checkboxes = $content.find('input[type="checkbox"]');

                if (window.topics) {
                    $checkboxes.each(function () {
                        var $checkbox = $(this);
                        var isChecked = window.topics.indexOf($checkbox.val()) != -1;

                        $checkbox.prop('checked', isChecked);
                    });
                }

                var $resetCTA = $instance.find('.popover__cta.popover__cta--reset');
                $resetCTA.unbind('click');
                $resetCTA.click(function () {
                    $checkboxes.each(function () {
                        $(this).prop('checked', false);
                      });
                      
                    updateNumberOfChecked(topicContentDesktop);
                    runSearch();
                    instance.hide();
                });

                if (!window.topics.length) {
                    $resetCTA.addClass('popover__cta--hidden');
                }
                else {
                    $resetCTA.removeClass('popover__cta--hidden');
                }

                $closeCTA = $instance.find('.popover__close-cta');
                $closeCTA.unbind('click');
                if ($closeCTA) {
                    $closeCTA.click(function () {
                        instance.hide();
                    });
                }

                var $applyCTA = $instance.find('.popover__cta.popover__cta--apply');
                $applyCTA.unbind('click');
                $applyCTA.click(function () {
                    runSearch();
                    instance.hide();
                });
                
                $checkboxes.unbind('click');
                $checkboxes.click(function (e) {
                    var $checkbox = $(this);
                    var $parentInputListItem = $checkbox.closest('.popover__input-list-item');
                    var $childrenContainer = $parentInputListItem.find('.popover__input-list');
                    var isParent = $childrenContainer.length > 0;
                    var isChecked = $checkbox.is(':checked');

                    if (isParent && isChecked) {
                        var $childCheckboxes = $childrenContainer.find('input[type="checkbox"]:not(:disabled)');
                        $childCheckboxes.each(function () {
                            $(this).prop('checked', true);
                          });
                          
                        }
                    updateNumberOfChecked(topicContentDesktop);
                });

                var runSearch = function () {
                    var topics = [];
                    var hasAnyChecked = false;

                    $checkboxes.each(function () {
                        if ($(this).is(':checked')) {
                            topics.push($(this).val());
                            hasAnyChecked = true;
                        }
                    });

                    window.topics = topics;
                    if (hasAnyChecked) {
                        $resetCTA.removeClass('popover__cta--hidden');
                    }
                    else {
                        $resetCTA.addClass('popover__cta--hidden');
                    }

                    updateFiltersAndContent();
                  };
              updateNumberOfChecked(topicContentDesktop);
            }
        })[0];

        $topicContentDesktopContent = $(topicTooltip.popperChildren.content);
        window.$topicContentDesktopContent = $topicContentDesktopContent;
    }

    if (topicContentTouch) {
        setPopoverGroup(topicContentTouch);
        $topicModal = $('.dropdown-filter--topic--touch').modaal({
            content_source: topicContentTouch,
            custom_class: 'modaal-wrapper--spacingless modaal-wrapper--no-close-btn modaal-wrapper--full-height',
            type: 'inline',
            overlay_opacity: .8,
            after_open: function (modal_wrapper) {
                var $content = $(modal_wrapper);
                window.$topicModalContent = $content;

                var $checkboxes = $content.find('input[type="checkbox"]');

                if (window.topics) {
                    var isAnyChecked = false;
                    $checkboxes.each(function () {
                        var $checkbox = $(this);
                        var isChecked = window.topics.indexOf($checkbox.val()) != -1;

                        $checkbox.prop('checked', isChecked);
                    });
                }

                var $resetCTA = $content.find('.popover__cta.popover__cta--reset');
                $resetCTA.unbind('click');
                $resetCTA.click(function () {
                    $checkboxes.each(function () {
                        $(this).prop('checked', false);
                    });
                    
                    updateNumberOfChecked('.modaal-wrapper');
                    runSearch();
                    $topicModal.modaal('close');
                });

                if (!window.topics.length) {
                    $resetCTA.addClass('popover__cta--hidden');
                }
                else {
                    $resetCTA.removeClass('popover__cta--hidden');
                }

                var $closeCTA = $content.find('.popover__close-cta');
                $closeCTA.unbind('click');
                $closeCTA.click(function () {
                    $topicModal.modaal('close');
                });

                var $applyCTA = $content.find('.popover__cta.popover__cta--apply');
                $applyCTA.unbind('click');
                $applyCTA.click(function () {
                    runSearch();
                    $topicModal.modaal('close');
                });

                $checkboxes.unbind('click');
                $checkboxes.click(function (e) {
                    var $checkbox = $(this);
                    var $parentInputListItem = $checkbox.closest('.popover__input-list-item');
                    var $childrenContainer = $parentInputListItem.find('.popover__input-list');
                    var isParent = $childrenContainer.length > 0;
                    var isChecked = $checkbox.is(':checked');

                    if (isParent && isChecked) {
                        var $childCheckboxes = $childrenContainer.find('input[type="checkbox"]:not(:disabled)');

                        $childCheckboxes.each(function () {
                            $(this).prop('checked', true);
                        });
                    }
                    updateNumberOfChecked('.modaal-wrapper');
                });

                var $collapseGroups = $content.find('.popover__group--collapse');
                $collapseGroups.each(function () {
                    var $collapseGroup = $(this);
                    var $trigger = $collapseGroup.find('.circle-plus-minus-icon');
                    var $content = $collapseGroup.find('.popover__group-content');

                    $trigger.unbind('click');
                    $trigger.click(function () {
                        if ($collapseGroup.hasClass(collapseGroupActiveClass)) {
                            $collapseGroup.removeClass(collapseGroupActiveClass);
                            $trigger.removeClass(triggerActiveClass);
                            $content.css({ 'height': '' });
                        }
                        else {
                            $collapseGroup.addClass(collapseGroupActiveClass);
                            var height = $content.find('> .popover__input-list').outerHeight(true);
                            $trigger.addClass(triggerActiveClass);
                            $content.css({ 'height': height + 'px' });
                        }
                    });

                    var $groupedCheckboxes = $collapseGroup.find('input[type="checkbox"]');
                    var isGroupChecked = false;

                    $groupedCheckboxes.each(function () {
                        var isChecked = $(this).is(':checked');

                        if (isChecked) {
                            isGroupChecked = true;
                        }
                    });

                    if (isGroupChecked) {
                        $collapseGroup.addClass('popover__group-content--active');
                    }
                    else {
                        $collapseGroup.removeClass('popover__group-content--active');
                    }
                });

                var runSearch = function () {
                    var topics = [];
                    var hasAnyChecked = false;

                    $checkboxes.each(function () {
                        if ($(this).is(':checked')) {
                            topics.push($(this).val());
                            hasAnyChecked = true;
                        }
                    });

                    window.topics = topics;
                    if (hasAnyChecked) {
                        $resetCTA.removeClass('popover__cta--hidden');
                    }
                    else {
                        $resetCTA.addClass('popover__cta--hidden');
                    }

                    updateFiltersAndContent();
                };
                updateNumberOfChecked('.modaal-wrapper');
            },
            before_close: function (modal_wrapper) {
                var $content = $(modal_wrapper);

                var $collapseGroups = $content.find('.popover__group--expanded');
                $collapseGroups.each(function () {
                    var $collapseGroup = $(this);
                    var $trigger = $collapseGroup.find('.circle-plus-minus-icon');
                    var $content = $collapseGroup.find('.popover__group-content');

                    $collapseGroup.removeClass(collapseGroupActiveClass);
                    $trigger.removeClass(triggerActiveClass);
                    $content.css({ 'height': '' });
                });
            }
        });
    }

    if (regionContentDesktop) {
        regionTooltip = tippy('.dropdown-filter--region--desktop', {
            maxWidth: 'none',
            theme: 'light',
            placement: 'bottom-start',
            flip: false,
            content: regionContentDesktop,
            onMount: function (instance) {
                var $instance = $(instance.popper);
                var $content = $(instance.props.content);

                var $checkboxes = $content.find('input[type="checkbox"]');

                if (window.regions) {
                    $checkboxes.each(function () {
                        var $checkbox = $(this);
                        var isChecked = window.regions.indexOf($checkbox.val()) != -1;

                        $checkbox.prop('checked', isChecked);
                    });
                }

                var $resetCTA = $instance.find('.popover__cta.popover__cta--reset');
                $resetCTA.unbind('click');
                $resetCTA.click(function () {
                    $checkboxes.each(function () {
                        $(this).prop('checked', false);
                    });

                    runSearch();
                    instance.hide();
                });

                if (!window.regions.length) {
                    $resetCTA.addClass('popover__cta--hidden');
                }
                else {
                    $resetCTA.removeClass('popover__cta--hidden');
                }

                $closeCTA = $instance.find('.popover__close-cta');
                $closeCTA.unbind('click');
                if ($closeCTA) {
                    $closeCTA.click(function () {
                        instance.hide();
                    });
                }

                var $applyCTA = $instance.find('.popover__cta.popover__cta--apply');
                $applyCTA.unbind('click');
                $applyCTA.click(function () {
                    runSearch();
                    instance.hide();
                });

                var runSearch = function () {
                    var regions = [];
                    var hasAnyChecked = false;

                    $checkboxes.each(function () {
                        if ($(this).is(':checked')) {
                            regions.push($(this).val());
                            hasAnyChecked = true;
                        }
                    });

                    window.regions = regions;
                    if (hasAnyChecked) {
                        $resetCTA.removeClass('popover__cta--hidden');
                    }
                    else {
                        $resetCTA.addClass('popover__cta--hidden');
                    }

                    if (window.regions.length) {
                        $('.dropdown-filter--region').addClass('dropdown-filter--active');
                    }
                    else {
                        $('.dropdown-filter--region').removeClass('dropdown-filter--active');
                    }

                    updateFiltersAndContent();
                };
            }
        })[0];

        $regionContentDesktopContent = $(regionTooltip.popperChildren.content);
        window.$regionContentDesktopContent = $regionContentDesktopContent;
    }

    if (regionContentTouch) {
        $regionModal = $('.dropdown-filter--region--touch').modaal({
            content_source: regionContentTouch,
            custom_class: 'modaal-wrapper--spacingless modaal-wrapper--no-close-btn modaal-wrapper--full-height',
            type: 'inline',
            overlay_opacity: .8,
            after_open: function (modal_wrapper) {
                var $content = $(modal_wrapper);
                window.$regionModalContent = $content;

                var $checkboxes = $content.find('input[type="checkbox"]');

                if (window.regions) {
                    var isAnyChecked = false;
                    $checkboxes.each(function () {
                        var $checkbox = $(this);
                        var isChecked = window.regions.indexOf($checkbox.val()) != -1;

                        $checkbox.prop('checked', isChecked);
                    });
                }

                var $resetCTA = $content.find('.popover__cta.popover__cta--reset');
                $resetCTA.unbind('click');
                $resetCTA.click(function () {
                    $checkboxes.each(function () {
                        $(this).prop('checked', false);
                    });

                    runSearch();
                    $regionModal.modaal('close');
                });

                if (!window.regions.length) {
                    $resetCTA.addClass('popover__cta--hidden');
                }
                else {
                    $resetCTA.removeClass('popover__cta--hidden');
                }

                var $closeCTA = $content.find('.popover__close-cta');
                $closeCTA.unbind('click');
                $closeCTA.click(function () {
                    $regionModal.modaal('close');
                });

                var $applyCTA = $content.find('.popover__cta.popover__cta--apply');
                $applyCTA.unbind('click');
                $applyCTA.click(function () {
                    runSearch();
                    $regionModal.modaal('close');
                });

                var runSearch = function () {
                    var regions = [];
                    var hasAnyChecked = false;

                    $checkboxes.each(function () {
                        if ($(this).is(':checked')) {
                            regions.push($(this).val());
                            hasAnyChecked = true;
                        }
                    });

                    window.regions = regions;
                    if (hasAnyChecked) {
                        $resetCTA.removeClass('popover__cta--hidden');
                    }
                    else {
                        $resetCTA.addClass('popover__cta--hidden');
                    }

                    if (window.regions.length) {
                        $('.dropdown-filter--region').addClass('dropdown-filter--active');
                    }
                    else {
                        $('.dropdown-filter--region').removeClass('dropdown-filter--active');
                    }

                    updateFiltersAndContent();
                };
            }
        });
    }

    if (contentLabelContentDesktop) {
        contentLabelTooltip = tippy('.dropdown-filter--content-label--desktop', {
            maxWidth: 'none',
            theme: 'light',
            placement: 'bottom-start',
            flip: false,
            content: contentLabelContentDesktop,
            onMount: function (instance) {
                var $instance = $(instance.popper);
                var $content = $(instance.props.content);

                var $checkboxes = $content.find('input[type="checkbox"]');

                if (window.contentLabels) {
                    $checkboxes.each(function () {
                        var $checkbox = $(this);
                        var isChecked = window.contentLabels.indexOf($checkbox.val()) != -1;

                        $checkbox.prop('checked', isChecked);
                    });
                }

                var $resetCTA = $instance.find('.popover__cta.popover__cta--reset');
                $resetCTA.unbind('click');
                $resetCTA.click(function () {
                    $checkboxes.each(function () {
                        $(this).prop('checked', false);
                    });

                    runSearch();
                    instance.hide();
                });

                if (!window.contentLabels.length) {
                    $resetCTA.addClass('popover__cta--hidden');
                }
                else {
                    $resetCTA.removeClass('popover__cta--hidden');
                }

                $closeCTA = $instance.find('.popover__close-cta');
                $closeCTA.unbind('click');
                if ($closeCTA) {
                    $closeCTA.click(function () {
                        instance.hide();
                    });
                }

                var $applyCTA = $instance.find('.popover__cta.popover__cta--apply');
                $applyCTA.unbind('click');
                $applyCTA.click(function () {
                    runSearch();
                    instance.hide();
                });

                var runSearch = function () {
                    var contentLabels = [];
                    var hasAnyChecked = false;

                    $checkboxes.each(function () {
                        if ($(this).is(':checked')) {
                            contentLabels.push($(this).val());
                            hasAnyChecked = true;
                        }
                    });

                    window.contentLabels = contentLabels;
                    if (hasAnyChecked) {
                        $resetCTA.removeClass('popover__cta--hidden');
                    }
                    else {
                        $resetCTA.addClass('popover__cta--hidden');
                    }

                    if (window.contentLabels.length) {
                        $('.dropdown-filter--content-label').addClass('dropdown-filter--active');
                    }
                    else {
                        $('.dropdown-filter--content-label').removeClass('dropdown-filter--active');
                    }

                    updateFiltersAndContent();
                };
            }
        })[0];

        $contentLabelContentDesktopContent = $(contentLabelTooltip.popperChildren.content);
        window.$contentLabelContentDesktopContent = $contentLabelContentDesktopContent;
    }

    if (contentLabelContentTouch) {
        $contentLabelModal = $('.dropdown-filter--content-label--touch').modaal({
            content_source: contentLabelContentTouch,
            custom_class: 'modaal-wrapper--spacingless modaal-wrapper--no-close-btn modaal-wrapper--full-height',
            type: 'inline',
            overlay_opacity: .8,
            after_open: function (modal_wrapper) {
                var $content = $(modal_wrapper);
                window.$contentLabelModalContent = $content;

                var $checkboxes = $content.find('input[type="checkbox"]');

                if (window.contentLabels) {
                    var isAnyChecked = false;
                    $checkboxes.each(function () {
                        var $checkbox = $(this);
                        var isChecked = window.contentLabels.indexOf($checkbox.val()) != -1;

                        $checkbox.prop('checked', isChecked);
                    });
                }

                var $resetCTA = $content.find('.popover__cta.popover__cta--reset');
                $resetCTA.unbind('click');
                $resetCTA.click(function () {
                    $checkboxes.each(function () {
                        $(this).prop('checked', false);
                    });

                    runSearch();
                    $contentLabelModal.modaal('close');
                });

                if (!window.contentLabels.length) {
                    $resetCTA.addClass('popover__cta--hidden');
                }
                else {
                    $resetCTA.removeClass('popover__cta--hidden');
                }

                var $closeCTA = $content.find('.popover__close-cta');
                $closeCTA.unbind('click');
                $closeCTA.click(function () {
                    $contentLabelModal.modaal('close');
                });

                var $applyCTA = $content.find('.popover__cta.popover__cta--apply');
                $applyCTA.unbind('click');
                $applyCTA.click(function () {
                    runSearch();
                    $contentLabelModal.modaal('close');
                });

                var runSearch = function () {
                    var contentLabels = [];
                    var hasAnyChecked = false;

                    $checkboxes.each(function () {
                        if ($(this).is(':checked')) {
                            contentLabels.push($(this).val());
                            hasAnyChecked = true;
                        }
                    });

                    window.contentLabels = contentLabels;
                    if (hasAnyChecked) {
                        $resetCTA.removeClass('popover__cta--hidden');
                    }
                    else {
                        $resetCTA.addClass('popover__cta--hidden');
                    }

                    if (window.contentLabels.length) {
                        $('.dropdown-filter--content-label').addClass('dropdown-filter--active');
                    }
                    else {
                        $('.dropdown-filter--content-label').removeClass('dropdown-filter--active');
                    }

                    updateFiltersAndContent();
                };
            }
        });

        window.$regionModal = $regionModal;
    }

    var resizePopoverGroups = function () {
      var activeClass = 'circle-plus-minus-icon--is-active';

      var $collapseGroups = $('.popover__group--collapse');
      $collapseGroups.each(function () {
          var $collapseGroup = $(this);
          var $trigger = $collapseGroup.find('.circle-plus-minus-icon');
          var $content = $collapseGroup.find('.popover__group-content');
          if (ICF.Utils.Breakpoints.IsTablet() && $trigger.hasClass(activeClass)) {
              var height = $content.find('> .popover__input-list').outerHeight(true);
              $content.css({ 'height': height + 'px' });
          }

          else {
              $content.css({ 'height': '' });
              $trigger.removeClass(activeClass);
          }
      });
  }

  var resizeTopicDropdown = function() {
    if(ICF.Utils.Breakpoints.IsDesktop() && $('.dropdown-filter--topic--desktop').length) {
      var topicDropdown = $("#TopicFiltering");
      var popoverBottom = $('.popover__bottom', topicDropdown)[0];
      var windowHeight = window.innerHeight;
      var topicDropdownCTAPosition = $('.dropdown-filter--topic--desktop')[0].getBoundingClientRect().top;
      
      if(popoverBottom) {
        
        if (topicDropdown.height() !== windowHeight - topicDropdownCTAPosition - popoverBottom.clientHeight ) {
          topicDropdown.css({'height': windowHeight - topicDropdownCTAPosition - popoverBottom.clientHeight + 'px'})
        }
      }
    }
  }

  $(window).resize(function () {
      resizePopoverGroups();
      resizeTopicDropdown();

      if (ICF.Utils.Breakpoints.IsDesktop()) {
        if (!!$topicModal) {
          $topicModal.modaal('close');
        }
        if (!!$regionModal) {
          $regionModal.modaal('close');
        }
      } 
      else {
        if (!!topicTooltip) {
          topicTooltip.hide();
        }
        if (!!regionTooltip) {
          regionTooltip.hide();
        }
      }
  });
};